<template>
  <div>
    <section class="xs-banner service-banner contet-to-center">
      <div class="container">
<!--       <h1>404</h1>-->
      </div><!-- .container END -->
    </section>
    <div class="page" role="main">
      <div class="builder-content">
        <!-- full-width-content -->
        <div id="post-32" class="full-width-content post-32 page type-page status-publish hentry">
          <h1 class="m-auto text-center p-5">404 NOT FOUND</h1>
        </div> <!-- end full-width-content -->
      </div> <!-- end main-content -->

    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFound'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/NotFound.vue